import axios from "axios";
import { useState, useEffect } from "react";

const endpoint = "https://fumapi.testwebspace.co.uk";

function getStoredAuthToken() {
  return (
    window.localStorage.getItem("accessToken") ||
    window.localStorage.getItem("idToken") ||
    ""
  );
}

async function waitForStoredAuthToken({ timeoutMs = 2500, pollMs = 50 } = {}) {
  const started = Date.now();
  let token = getStoredAuthToken();
  while (!token && Date.now() - started < timeoutMs) {
    await new Promise((r) => setTimeout(r, pollMs));
    token = getStoredAuthToken();
  }
  return token;
}

async function authConfigAsync() {
  const token = getStoredAuthToken() || (await waitForStoredAuthToken());
  if (!token) {
    throw new Error("Missing auth token (idToken/accessToken) in localStorage.");
  }
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const useGetRequest = (path) => {
  const [status, setStatus] = useState("idle");
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setStatus("fetching");
      try {
        const auth = await authConfigAsync();
        const res = await axios.get(`${endpoint}/${path}`, auth);
        if (res) setData(res.data);
        setStatus("fetched");
      } catch (e) {
        console.error(e);
        setStatus("error");
      }
    };

    fetchData();
  }, [path]);

  return { status, data };
};

export const sendPostRequest = async (path, params) => {
  const auth = await authConfigAsync();
  const res = await axios.post(`${endpoint}/${path}`, params, auth);

  return res.data;
};

export const sendGetRequest = async (path, params) => {
  const auth = await authConfigAsync();
  const res = await axios.get(`${endpoint}/${path}`, {
    ...auth,
    ...(params ? { params } : {}),
  });

  return res.data;
};
